import type { ApiFeature } from '@app/packages/internalApi/types'
import { createInternalApiAction } from '@app/packages/internalApi/utils'

export const getFeatures = () =>
  createInternalApiAction('getFeatures', dispatch =>
    dispatch<{ data: ApiFeature[] }>({
      method: 'GET',
      endpoint: '/internal/api/v1/features',
    })
  )
